import React from 'react';
import TextInput from 'src/ui/library/TextInput';
import TextMask from './TextMask';

class PhoneInput extends React.Component {
  state = {
    value: this.props.value || '',
  };

  handleChange = event => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }

    this.setState({
      value: event.target.value,
    });
  };

  render() {
    const { onChange, value, ...otherProps } = this.props;

    return (
      <TextInput
        onChange={this.handleChange}
        InputProps={{
          inputComponent: TextMask,
          value: this.state.value,
        }}
        {...otherProps}
      />
    );
  }
}

export default PhoneInput;
